<template>
  <BaseCard class="equipmentCard" :disabled="disabled" :true-value="trueValue" :value="value" :checkbox="checkbox" :clickable="clickable" :check-icon="checkIcon">
    <template v-slot:title>{{ equipmentObj.name }}</template>
    <template v-slot:subtitle>{{ subtitle }}</template>
    <template v-if="equipmentObj.armor" v-slot:abilitySmall>Armor</template>
    <template v-if="equipmentObj.armor" v-slot:ability>+{{ equipmentObj.armor.amount }}</template>
    <template v-if="equipmentObj.action" v-slot:action><span style="text-transform: captitalize">{{ equipmentObj.action }}</span></template><!-- TODO Better -->
    <template v-else-if="equipmentObj.armor || equipmentObj.consumable" v-slot:action>Action</template>

    <Text>{{ description }}</Text>
    <template v-if="equipmentObj.requiresRested">
      <Tags>
        <span>Rested</span>
      </Tags>
    </template>
    <Price>{{ calcPrice(equipmentObj) }}</Price>
  </BaseCard>
</template>

<script>
import { defineComponent, computed, inject } from 'vue'

import BaseCard from '@/components/cards/BaseCard'
import Text from '@/components/cards/content/Text'
import Price from '@/components/cards/content/Price'
import Tags from '@/components/cards/content/Tags'

import cardProps from '@/helpers/cardProps'
import parseDescription from '@/helpers/parseDescription'

import equipmentList from '@/data/equipment'
import weaponList from '@/data/weapons'

export default defineComponent({
  props: {
    equipment: {
      type: String,
      required: true
    },

    ...cardProps
  },

  components: {
    Text,
    Price,
    Tags,
    BaseCard
  },

  setup (props) {
    const character = inject('character')

    const equipmentObj = computed(() => {
      return equipmentList[props.equipment] || weaponList[props.equipment]
    })

    const subtitle = computed(() => {
      const qty = (typeof character?.inventory[props.equipment] === 'number')
          ? character.inventory[props.equipment]
          : equipmentObj.value.consumable
      
      if (equipmentObj.value.armor) {
        let str = ''
        if (equipmentObj.value.tags.includes('shield')) {
          str += 'Shield'
        } else {
          if (equipmentObj.value.tags.includes('lightArmor')) str = 'Light '
          else if (equipmentObj.value.tags.includes('mediumArmor')) str = 'Medium '
          else if (equipmentObj.value.tags.includes('heavyArmor')) str = 'Heavy '
          str += 'Armor'
        }
        return str + (equipmentObj.value.armor?.noisy ? ', Noisy' : '')
      } else if (qty) {
        return equipmentObj.value.consumable
          ? `${equipmentObj.value.charges ? 'Charges' : 'Consumable'} (x${qty})`
          : `(x${qty})`
      }

      return equipmentObj.value.type || 'Item'
    })

    const computedCharacter = inject('computedCharacter')
    const description = computed(() => parseDescription(computedCharacter, equipmentObj.value))

    const calcPrice = (item) => {
      const key = item.key
      let price = item.price
      if (!item.charges && (character.inventory[key] > 1 || item.consumable > 1)) {
        const qty = (character.inventory[key] >= 0 && character.inventory[key]) || item.consumable
        price *= qty
        return `${price} (${item.price} ea.)`
      }
      return price
    }

    return {
      equipmentObj,
      subtitle,
      description,
      calcPrice
    }
  }
})
</script>
